var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scrollToToc } from "../../Viewer/actions/uiActions";
import Immutable from 'immutable';
import ShowIf from "../../App/ShowIf";
import { t } from "../../I18N";
import { Icon } from "../../UI";

import "./scss/showToc.scss";

export class ShowToc extends Component {
  scrollTo(tocElement, e) {
    e.preventDefault();
    this.props.scrollToToc(tocElement.toJS());
  }

  render() {
    const toc = Immutable.fromJS(this.props.toc);

    if (!toc.size) {
      return /*#__PURE__*/(
        _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
        _jsx(Icon, { icon: "font" }), /*#__PURE__*/
        _jsx("h4", {}, void 0, t('System', 'No Table of Contents')), /*#__PURE__*/
        _jsx("p", {}, void 0, t('System', 'No Table of Contents description'))));


    }

    return /*#__PURE__*/(
      _jsx("div", { className: "toc" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "toc-view" }, void 0,
      toc.map((tocElement, index) => /*#__PURE__*/
      _jsx("li", { className: `toc-indent-${tocElement.get('indentation')}` }, index, /*#__PURE__*/
      _jsx(ShowIf, { if: !this.props.readOnly }, void 0, /*#__PURE__*/
      _jsx("a", {
        className: "toc-view-link",
        href: "#",
        onClick: this.scrollTo.bind(this, tocElement) }, void 0,

      tocElement.get('label'), /*#__PURE__*/
      _jsx("span", { className: "page-number" }, void 0,
      tocElement.getIn(['selectionRectangles', 0]) &&
      tocElement.getIn(['selectionRectangles', 0]).get('page')))), /*#__PURE__*/



      _jsx(ShowIf, { if: this.props.readOnly }, void 0, /*#__PURE__*/
      _jsx("span", { className: "toc-view-link" }, void 0, tocElement.get('label'))))))));






  }
}

ShowToc.defaultProps = {
  toc: []
};







function mapDispatchToProps() {
  return { scrollToToc };
}

export default connect(null, mapDispatchToProps)(ShowToc);